import { InputAdornment } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import React from "react";
import { TextInput } from "react-admin";

const SearchInput = (props) => {
	return (
		<TextInput
			{...props}
			resettable
			helperText={false}
			InputProps={{
				endAdornment: (
					<InputAdornment>
						<SearchIcon color="disabled" />
					</InputAdornment>
				),
			}}
		/>
	);
};

export default SearchInput;
